import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfiguracionBloqueoDTO } from '@shared/models/controlCredito/ConfiguracionBloqueoDTO';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { Usuario } from '@shared/models/despacho/Usuario';
import { UsuarioService } from '@account/usuario.service';
import { MessageService } from "@shell/message.service";
import { ErrorModel } from "@shared/models/ErrorModel";

@Component({
  selector: 'app-configuracion-bloqueo-automatico',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './configuracion-bloqueo-automatico.component.html',
  styleUrls: ['./configuracion-bloqueo-automatico.component.scss']
})
export class ConfiguracionBloqueoAutomaticoComponent implements OnInit {
  
  form!: FormGroup;
  @Input() cliente: any;
  @Input() configuracion: ConfiguracionBloqueoDTO;
  grabando: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private controlCreditoService: ControlCreditoService,
    public activeModal: NgbActiveModal,
    private usuarioService: UsuarioService
  ) {}

  ngOnInit(): void {
    this.crearForm();
  }

  crearForm() {
    this.form = this.fb.group({
      noBloquearPorVencido: [this.configuracion?.noBloquearPorVencido ?? false],
      noBloquearDiasInhabilesVencido: [this.configuracion?.noBloquearDiasInhabilesVencido ?? false],
      noBloquearPorExcedido: [this.configuracion?.noBloquearPorExcedido ?? false],
      noBloquearDiasInhabilesExcedido: [this.configuracion?.noBloquearDiasInhabilesExcedido ?? false]
    });

    this.form.get('noBloquearPorVencido')!.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('noBloquearDiasInhabilesVencido')!.setValue(false, { emitEvent: false });
      }
    });
    this.form.get('noBloquearDiasInhabilesVencido')!.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('noBloquearPorVencido')!.setValue(false, { emitEvent: false });
      }
    });

    this.form.get('noBloquearPorExcedido')!.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('noBloquearDiasInhabilesExcedido')!.setValue(false, { emitEvent: false });
      }
    });
    this.form.get('noBloquearDiasInhabilesExcedido')!.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('noBloquearPorExcedido')!.setValue(false, { emitEvent: false });
      }
    });
  }
    
  obtenerUsuarioLogueado() {
    const u = new Usuario();
    u.dni = this.usuarioService.getDniOperador();
    u.nombresCompletos = this.usuarioService.getNombresOperador();
    u.email = this.usuarioService.getEmailUsuario();
    return u;
  }

  onGuardar(): void {
    if (this.form.valid) {
      this.grabando = true;
      const configuracion = ConfiguracionBloqueoDTO.fromForm(this.form);
      configuracion.usuarioSolicitante = this.obtenerUsuarioLogueado();
      this.controlCreditoService.configurarBloqueoCliente(this.cliente.id, configuracion)
        .subscribe(() => {
          this.messageService.showSuccessMessage('Se realizó la solicitud de configuración correctamente');
          this.grabando = false;
          this.activeModal.close(this.form.value);
        }, (err: ErrorModel) => {
          this.messageService.showErrorMessage("No se pudo realizar la solicitud correctamente: " + err.description);
          this.grabando = false;
        });
    }
  }

  onCancelar(): void {
    this.activeModal.close();
  }
}